<rlst-modal header="Exceeds Maximum Results" (closeModal)="close(SearchMaximumResultsAction.REFINE_SEARCH)">
  <div class="content confirmation-content flex-column">
    <p class="message-title">
      <span class="pr-1">
        <i class="fas fa-question-circle" aria-hidden="true"></i>
      </span>
      More than {{data.maxRecordsToSearch}} results exist for this search.
    </p>
    <p class="confirmation-message pl-4">Please choose the method to continue</p>
  </div>
  <div mat-dialog-actions class="actions-panel">
    <button class="btn-custom btn-custom-outline-blue-dark d-none d-md-block"
            (click)="close(SearchMaximumResultsAction.EXPORT_RESULTS)">
      Export Results
    </button>
    <ng-container *ngIf="(isLabelPreferenceEnabled$ | async)">
      <button class="btn-custom btn-custom-outline-blue-dark d-none d-md-block"
              (click)="close(SearchMaximumResultsAction.CREATE_LABELS)">
        Create Labels
      </button>
    </ng-container>
    <button class="btn-custom btn-custom-outline-blue-dark"
            (click)="close(SearchMaximumResultsAction.SHOW_RESULTS)">
      Show First {{data.maxRecordsToSearch}}
    </button>
    <button class="btn-custom btn-custom-blue-dark"
            (click)="close(SearchMaximumResultsAction.REFINE_SEARCH)">
      Refine Search
    </button>
  </div>
</rlst-modal>
